<template lang="pug">
f7-popup(:opened='opened')
  f7-page
    popup-navigation-bar(title='並びかえ', @close='$emit("close")')
    background
      .sort-selections
        label.custom-radio(v-for='condition in conditions')
          | {{ condition.label }}
          input(
            type='radio',
            v-model='selectedSort',
            name='radio',
            :value='condition.value',
            @change='onChange'
          )
          span.checkmark
</template>

<script>
import LargeButton from '@/components/atoms/LargeButton'
export default {
  components: { LargeButton },
  props: {
    opened: { type: Boolean },
  },
  data() {
    return {
      selectedSort: 'RATING_QUALITY',
      conditions: [
        { value: 'RATING_QUALITY', label: '標準' },
        { value: 'REVIEW_RATE_AVERAGE', label: 'レビューの評価が高い順' },
        { value: 'REVIEW_COUNT', label: 'レビューの件数が多い順' },
      ],
    }
  },
  methods: {
    onChange() {
      this.$emit('setSortCondition', this.selectedSort)
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/public-common.scss';

.sort-selections {
  padding: 86px 16px 16px;
}

.custom-radio {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 32px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  opacity: 0.9;
  font-family: 'Hiragino Sans';
  font-weight: 300;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;

    &:checked ~ .checkmark {
      border: 1px solid #1faab3;

      &:after {
        display: block;
      }
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: #111d2b;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 50%;

    &:after {
      content: '';
      position: absolute;
      display: none;
      top: 4px;
      left: 4px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #1faab3;
    }
  }
}

@media (min-height: 630px) and (min-width: 630px) {
  .popup:not(.popup-tablet-fullscreen) {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
}
</style>
